module.exports = __webpack_public_path__ + "img/favemeicom.2b8233b9.png";